import { render, staticRenderFns } from "./solution-item_v2.vue?vue&type=template&id=0ef5266e&scoped=true"
import script from "./solution-item_v2.vue?vue&type=script&lang=js"
export * from "./solution-item_v2.vue?vue&type=script&lang=js"
import style0 from "./solution-item_v2.vue?vue&type=style&index=0&id=0ef5266e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ef5266e",
  null
  
)

export default component.exports